import {BigNumber, ethers} from 'ethers';

export function makeAddressShort(address: string, length = 4) {
  return `${address.substring(0, length + 2)}…${address.substring(
    address.length - length
  )}`;
}

export const weiToEther = (amount: BigNumber): string => {
  return ethers.utils.formatEther(amount);
};

export const etherToWei = (amount: string): BigNumber => {
  return ethers.utils.parseEther(amount);
};

export function formatBalance(value: string | number): string {
  let num: number;

  if (typeof value === 'string') {
    const cleanValue = value.endsWith('n')
        ? value.substring(0, value.length - 1)
        : value;

    if (cleanValue.length > 15) {
      const isNegative = cleanValue.startsWith('-');
      const absValue = isNegative ? cleanValue.substring(1) : cleanValue;
      const etherValue = parseFloat(absValue) / 10**18;
      return (isNegative ? '-' : '') + formatBalance(etherValue);
    }

    num = parseFloat(cleanValue);
  } else {
    num = value;
  }

  if (!Number.isFinite(num)) {
    return '0';
  }

  const absNum = Math.abs(num);
  const sign = num < 0 ? '-' : '';

  if (absNum < 1000) {
    return sign + absNum.toFixed(absNum % 1 === 0 ? 0 : 2);
  } else if (absNum < 1_000_000) {
    const thousands = absNum / 1000;
    return sign + thousands.toFixed(thousands % 1 === 0 ? 0 : 1) + 'K';
  } else {
    const millions = absNum / 1_000_000;
    return sign + millions.toFixed(millions % 1 === 0 ? 0 : 1) + 'M';
  }
}

export const computeTransaction = (details: any, myWallet: string) => {
  if (!details || !myWallet) return null;
  const [, stakesBn, player1, player2, winner] = details;
  const myLowerWallet = myWallet.toLowerCase();
  const stakeDecimal = parseFloat(ethers.utils.formatUnits(stakesBn, 18));
  const zeroAddress = '0xdb2cc8e6747d81399dc6e6619220e8d46f3ce787';

  let depositAmount: number | null = null;
  const p1 = (player1 as string).toLowerCase();
  const p2 = (player2 as string).toLowerCase();
  const winAddr = (winner as string).toLowerCase();

  if (p1 === myLowerWallet) {
    if (p2 === myLowerWallet && winAddr === myLowerWallet) {
      depositAmount = stakeDecimal;
    } else if (p2 !== myLowerWallet) {
      if (winAddr === zeroAddress) {
        depositAmount = stakeDecimal;
      } else if (winAddr === myLowerWallet) {
        depositAmount = stakeDecimal * 2 * 0.9;
      }
    }
  } else if (p2 === myLowerWallet) {
    if (winAddr === zeroAddress) {
      depositAmount = stakeDecimal;
    } else if (winAddr === myLowerWallet) {
      depositAmount = stakeDecimal * 2 * 0.9;
    }
  }

  if (depositAmount !== null) {
    return {
      label: 'Account Deposit',
      value: '+' + formatBalance(depositAmount),
    };
  }
  return {
    label: 'Account Withdraw',
    value: '-' + formatBalance(stakeDecimal),
  };
};

/**
 * Проверяет авторизацию пользователя на основе наличия токенов и адреса кошелька
 * @param accountAddress Адрес подключенного кошелька (опционально)
 * @returns Boolean значение, указывающее на авторизацию пользователя
 */
export const checkUserAuthorization = (accountAddress?: string): boolean => {
  if (typeof window === 'undefined') return false;

  const hasWalletToken = (() => {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('walletToken-')) {
        return true;
      }
    }
    return false;
  })();

  const hasAccessToken = localStorage.getItem('access_token') !== null;

  return !!(hasWalletToken || hasAccessToken || accountAddress);
};
